import React from 'react';

import * as photosService from '../api/photos';

export const downloadPhoto = async (
  token: string,
  id: number | number[],
  setIsDownloading: React.Dispatch<React.SetStateAction<boolean>>,
  setErrorCommon: React.Dispatch<React.SetStateAction<string | undefined>>,
  albumId?: string,
) => {
  setIsDownloading(true);

  try {
    const res = await photosService.download(token, id, albumId);

    if (res?.downloadUrl) {
      window.location.href = res.downloadUrl;
    }
  } catch (e) {
    setErrorCommon((e as Error)?.message);
  } finally {
    setIsDownloading(false);
  }
};
